<template>
  <div class="object-header">
    <div>Reference# {{ headerData.referenceNumber }}</div>
    <div v-if="headerData.lastModified">Last modified by {{ headerData.lastModified }}</div>
    <div v-if="headerData.objectStatus">
      <Status :status="headerData.objectStatus" :object-type="headerData.objectType" />
    </div>
  </div>
</template>

<script>
import Status from '@/app/components/Status.vue';
export default {
  components: {
    Status
  },
  props: {
    headerData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables';

.object-header {
  display: flex;
  flex-direction: column;
  padding: $details-padding;
  border-bottom: 1px solid $row-border;
  align-items: flex-start;
  div {
    padding-bottom: 5px;
  }
}
</style>
